import { __spreadArrays } from "tslib";
var _recentSearchTexts = [];
export function GetRecentSearchTexts() {
    return __spreadArrays(_recentSearchTexts);
}
export function SetRecentSearchTexts(recentSearches, count) {
    _recentSearchTexts = recentSearches.splice(0, count);
    return __spreadArrays(_recentSearchTexts);
}
export var ErrorMessage = 'Some error occurred. Please try again';
//# sourceMappingURL=InternalGlobalSearch.types.js.map